export const processSteps = [
  {code: 'PAYROLL', name: 'Nómina'},
  {code: 'NOVELTIES', name: 'Novedades'},
  {code: 'ERRORS', name: 'Errores'},
  {code: 'PAYSLIPS', name: 'Prenómina'},
  {code: 'PAYMENTS', name: 'Pagos'},
]

export const findProcessStep = code => {
  return processSteps.filter(
    processStep => processStep.code.toUpperCase() === code.toUpperCase()
  )[0]
}
